import { Address } from '@aloft/toolkit-shared';
import { Block, Flex, Grid, Input } from '@aloft/toolkit-sui';
// eslint-disable-next-line aloft/no-sui-chakra
import { Input as ChakraInput } from '@aloft/toolkit-sui/chakra';

import { Controller, useFormContext } from 'react-hook-form';

import { useGoogleMapsLoader } from '../../hooks/googleMaps/useGoogleMapsLoader.ts';

export const AddressInput = ({
  addressLabel,
  lockAddress,
  isRequired = true,
}: {
  addressLabel?: string;
  lockAddress?: boolean;
  isRequired?: boolean;
}) => {
  const mapsLoader = useGoogleMapsLoader();
  const { control, setValue, trigger } = useFormContext();

  const handlePlaceChange = (address: Address) => {
    setValue('address', address);
    // Revalidate
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    trigger();
  };

  return (
    <Flex width="100%" gap={3} flexDirection="column">
      <Grid gridTemplateColumns="3fr 1fr 1.4fr" gap={2} alignItems="end">
        <Block __dangerDoNotUseSx={{ gridColumn: 'span 2 / span 2' }}>
          <Controller
            name="address.AddressLineText"
            control={control}
            render={({ field, fieldState }) => (
              <Input
                {...field}
                isRequired={isRequired}
                label={addressLabel || 'Comp Address'}
                type="locationAddressAutocomplete"
                mapsLoader={mapsLoader}
                onClear={() => field.onChange('')}
                isInvalid={fieldState.invalid}
                onPlaceChanged={handlePlaceChange}
                isDisabled={lockAddress}
              />
            )}
          />
        </Block>
        <Block>
          <Controller
            name="address.unitNumber"
            control={control}
            render={({ field, fieldState }) => (
              <ChakraInput
                {...field}
                isRequired={isRequired}
                type="text"
                placeholder="Suite/Apt #"
                isInvalid={fieldState.invalid}
                isDisabled={lockAddress}
              />
            )}
          />
        </Block>
        <Block>
          <Controller
            name="address.CityName"
            control={control}
            render={({ field, fieldState }) => (
              <ChakraInput
                {...field}
                isRequired={isRequired}
                type="text"
                placeholder="City"
                isInvalid={fieldState.invalid}
                isDisabled={lockAddress}
              />
            )}
          />
        </Block>
        <Block>
          <Controller
            name="address.StateCode"
            control={control}
            render={({ field, fieldState }) => (
              <ChakraInput
                {...field}
                isRequired={isRequired}
                type="text"
                placeholder="State"
                isInvalid={fieldState.invalid}
                isDisabled={lockAddress}
              />
            )}
          />
        </Block>
        <Block>
          <Controller
            name="address.PostalCode"
            control={control}
            render={({ field, fieldState }) => (
              <ChakraInput
                {...field}
                isRequired={isRequired}
                type="text"
                placeholder="Zip"
                isInvalid={fieldState.invalid}
                isDisabled={lockAddress}
              />
            )}
          />
        </Block>
      </Grid>
    </Flex>
  );
};
